import {gql} from 'apollo-boost';

export const updateFavoritesMutation = gql`
    mutation UpdateFavorites($favorites: [Int!]!){
        updateFavorites(data: {favorites: $favorites}) {
            id
        }
    }
`;
